import { css, cx } from 'emotion';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { BREAKPOINT_SMALL } from '../consts/breakpoints';

// #region Style
const main = css`
  opacity: 0.9;
  mix-blend-mode: multiply;
  border-radius: 15px;
  box-shadow: 12px 13px 45px 0 rgba(65, 64, 66, 0.25);
  background-color: #414042;
  color: #ffffff;
  padding: 22px 66px;
  font-size: 14px;
  min-height: 27px;
  @media (min-width: ${BREAKPOINT_SMALL}) {
    padding: 30px 120px 30px 38px;
    font-size: 20px;
  }
`;
// #endregion

interface IToastProps {
  message?: string;
  className?: string;
}

export const Toast = observer(({ message, className }: IToastProps) => (
  <div className={cx(main, className)}>{message}</div>
));
